import React, { useState, useEffect } from "react";
import purchaseOrderService from "./services/purchaseOrderService";

import POLineItemsTable from "./components/POLineItemsTable";
import POHeaderSection from "./components/POHeaderSection";
import POFooterActions from "./components/POFooterActions";
import POChargeTable from "./components/POChargeTable";

import POTermsConditionsDrawer from "./components/POTermsConditionsDrawer";

// ADDED poId PROP FOR EDIT MODE (NO EXISTING PROPS CHANGED)
const POCreateDrawer = ({ onClose, poId }) => {

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [maximized, setMaximized] = useState(true);

  const [form, setForm] = useState({
    vendor_id: "",
    requested_department_id: "",
    procurement_purpose: "STOCK",

    project_id: "",
    order_id: "",

    pr_id: "",
    indent_id: "",
    rfq_id: "",
    requested_department_id: "",
    payment_terms: "",
    delivery_terms: "",
    delivery_date: "",
    delivery_address_line1: "",
    delivery_address_line2: "",
    delivery_country: "INDIA",
    delivery_state: "",
    delivery_city: "",
    delivery_pincode: "",
    currency: "INR",
    remarks: "",
  });

  const [lines, setLines] = useState([]);
  
  const [charges, setCharges] = useState([]);

  const [terms, setTerms] = useState([]);

  const [showTermsDrawer, setShowTermsDrawer] =
  useState(false);

  const [saving, setSaving] = useState(false);

  // ===========================================================
  // Utility to Normalize Decimals from backend
  // ===========================================================

  const normalizeDecimal = (val) => {
    if (val === null || val === undefined || val === "") return 0;
    return parseFloat(val);
  };

  // ===========================================================
  // ===== GST CALCULATION LOGIC (EXISTING) ====================
  // ===========================================================

  const getLineTotal = (l) => {
    const qty = parseFloat(l.qty || 0);
    const rate = parseFloat(l.rate || 0);
    const discount = parseFloat(l.discount || 0);

    const gstRate = parseFloat(l.gst_rate || 0);

    let amount = qty * rate;
    amount = amount - discount;

    const gstAmount = (amount * gstRate) / 100;

    return amount + gstAmount;
  };

  const getLineGSTAmount = (l) => {
    const qty = parseFloat(l.qty || 0);
    const rate = parseFloat(l.rate || 0);
    const discount = parseFloat(l.discount || 0);
    const gstRate = parseFloat(l.gst_rate || 0);

    let amount = qty * rate;
    amount = amount - discount;

    return (amount * gstRate) / 100;
  };
  const getChargeAmountTotal = () => {
  return charges.reduce((sum, c) => {

    if (c.payer_type !== "COMPANY") {
      return sum;
    }

    return (
      sum +
      parseFloat(c.charge_amount || 0)
    );

  }, 0);
};

  const getChargeGSTTotal = () => {
  return charges.reduce((sum, c) => {

    if (c.payer_type !== "COMPANY") {
      return sum;
    }

    const amount = parseFloat(
      c.charge_amount || 0
    );

    const gstRate = parseFloat(
      c.gst_rate || 0
    );

    return (
      sum +
      (amount * gstRate) / 100
    );

  }, 0);
};

  const getSubTotal = () => {
  const materialSubTotal = lines.reduce((sum, l) => {
    const qty = parseFloat(l.qty || 0);
    const rate = parseFloat(l.rate || 0);
    const discount = parseFloat(l.discount || 0);

    let amount = qty * rate;
    amount = amount - discount;

    return sum + amount;
  }, 0);

  return materialSubTotal + getChargeAmountTotal();
};

  const getTotalGST = () => {
  const materialGST = lines.reduce(
    (sum, l) => sum + getLineGSTAmount(l),
    0
  );

  return materialGST + getChargeGSTTotal();
};

  const getTotal = () => {
  return getSubTotal() + getTotalGST();
};

  // ===========================================================
  // ===== EDIT MODE: LOAD EXISTING PO =========================
  // ===========================================================

  useEffect(() => {
    const loadPO = async () => {
      if (!poId) return;

      try {
        const res = await purchaseOrderService.getPODetail(poId);

        if (res.success) {
          const po = res.data;

          setForm({
            vendor_id: po.vendor_id || "",
            requested_department_id:
              po.requested_department_id || "",
            procurement_purpose: po.procurement_purpose || "STOCK",
            requested_department_id:
              po.requested_department_id || "",

            project_id: po.project_id || "",
            order_id: po.order_id || "",

            pr_id: po.pr_id || "",
            indent_id: po.indent_id || "",
            rfq_id: po.source_ref_id || "",

            payment_terms: po.payment_terms || "",
            delivery_terms: po.delivery_terms || "",

            delivery_date: po.delivery_date
              ? po.delivery_date.substring(0, 10)
              : "",

            currency: po.currency || "INR",
            delivery_address_line1:
            po.delivery_address_line1 || "",

          delivery_address_line2:
            po.delivery_address_line2 || "",

          delivery_country:
            po.delivery_country || "INDIA",

          delivery_state:
            po.delivery_state || "",

          delivery_city:
            po.delivery_city || "",

          delivery_pincode:
            po.delivery_pincode || "",
            remarks: po.remarks || "",
          });

          const mappedLines = (po.lines || []).map((l) => ({
            ...l,

            material: l.material_id
                ? {
                    value: l.material_id,
                    label: l.material_name || ""
                  }
                : null,

            qty: normalizeDecimal(l.qty || l.ordered_qty),
            rate: normalizeDecimal(l.rate || l.unit_price),

            //discount: normalizeDecimal(l.discount),
            discount: normalizeDecimal(
                l.discount_amount ?? l.discount ?? 0
            ),      
            gst_rate: normalizeDecimal(l.gst_rate),
            cgst_rate: normalizeDecimal(l.cgst_rate),
            sgst_rate: normalizeDecimal(l.sgst_rate),
            igst_rate: normalizeDecimal(l.igst_rate),

            tax_code: l.tax_code || "",
            tax_classification_id: l.tax_classification_id || "",

            gst_amount: normalizeDecimal(l.gst_amount),
            taxable_amount: normalizeDecimal(l.taxable_amount),

            hsn_sac: l.tax_code || l.hsn_sac || ""
          }));

          setLines(mappedLines);

          const mappedCharges = (po.charges || []).map(c => ({
            id: c.id,

            charge_type: c.charge_type || "",
            payer_type: c.payer_type || "COMPANY",
            customer_id: c.customer_id || "",

            charge_amount: normalizeDecimal(c.charge_amount),

            gst_rate: normalizeDecimal(c.gst_rate),
            cgst_rate: normalizeDecimal(c.cgst_rate),
            sgst_rate: normalizeDecimal(c.sgst_rate),
            igst_rate: normalizeDecimal(c.igst_rate),

            gst_amount: normalizeDecimal(c.gst_amount),
            cgst_amount: normalizeDecimal(c.cgst_amount),
            sgst_amount: normalizeDecimal(c.sgst_amount),
            igst_amount: normalizeDecimal(c.igst_amount),

            total_amount: normalizeDecimal(c.total_amount),

            remarks: c.remarks || ""
          }));

          setCharges(mappedCharges);

          setTerms(po.terms || []);

          setSelectedVendor(
            po.vendor_id
              ? {
                  id: po.vendor_id,
                  name: po.vendor_name || `Vendor #${po.vendor_id}`
                }
              : null
          );


          // IMPORTANT FIX – also sync into form state
          setForm(prev => ({
            ...prev,
            vendor_id: po.vendor_id || ""
          }));

        }
      } catch (err) {
        alert("Failed to load PO details for edit");
      }
    };

    loadPO();
  }, [poId]);

  useEffect(() => {
  if (selectedVendor) {
    setForm((prev) => ({
      ...prev,
      vendor_id: selectedVendor.id
    }));
  }
}, [selectedVendor]);


  // ===========================================================
  // ===== SUBMIT HANDLER (CREATE OR EDIT) =====================
  // ===========================================================

  const handleSubmit = async () => {
  
     console.log("===== SAVE CLICK DEBUG =====");
    console.log("form.vendor_id:", form.vendor_id);
    console.log("selectedVendor:", selectedVendor);

    const finalVendorId = form.vendor_id || (selectedVendor ? selectedVendor.value : null);
     console.log("finalVendorId resolved as:", finalVendorId);

  if (!finalVendorId) {
    alert("Vendor is required");
    return;
  }
  if (!form.requested_department_id) {
  alert("Requested Department is required");
  return;
}
  if (!form.delivery_date) {
  alert("Delivery Date is required");
  return;
}

if (!form.delivery_country) {
  alert("Country is required");
  return;
}

if (!form.delivery_state) {
  alert("State is required");
  return;
}

if (!form.delivery_city) {
  alert("City is required");
  return;
}


    if (lines.length === 0) {
      alert("At least one material line required");
      return;
    }

    try {
      setSaving(true);

      const toIntOrNull = (v) => (v ? parseInt(v) : null);

      const safeLines = lines.map(l => ({
        ...l,

        qty: l.qty ? parseFloat(l.qty) : 0,
        rate: l.rate ? parseFloat(l.rate) : 0,
        discount: l.discount ? parseFloat(l.discount) : 0,

        gst_rate: l.gst_rate ? parseFloat(l.gst_rate) : 0,
        cgst_rate: l.cgst_rate ? parseFloat(l.cgst_rate) : 0,
        sgst_rate: l.sgst_rate ? parseFloat(l.sgst_rate) : 0,
        igst_rate: l.igst_rate ? parseFloat(l.igst_rate) : 0
      }));
      console.log(
        "SAFE LINES",
        JSON.stringify(safeLines, null, 2)
      );
      const payload = {
        ...form,
        vendor_id: finalVendorId,
        terms: terms,
        project_id: toIntOrNull(form.project_id),
        order_id: toIntOrNull(form.order_id),
        pr_id: toIntOrNull(form.pr_id),
        indent_id: toIntOrNull(form.indent_id),
        rfq_id: toIntOrNull(form.rfq_id),

        lines: safeLines,

        charges: charges.map(c => ({
          charge_type: c.charge_type,
          payer_type: c.payer_type,
          customer_id: c.customer_id
            ? Number(c.customer_id)
            : null,

          charge_amount: c.charge_amount
            ? parseFloat(c.charge_amount)
            : 0,

          gst_rate: c.gst_rate
            ? parseFloat(c.gst_rate)
            : 0,

          remarks: c.remarks || ""
        }))
      };

      let res;

      if (poId) {
        res = await purchaseOrderService.updatePO(poId, payload);
      } else {
        res = await purchaseOrderService.createDirectPO(payload);
      }

      if (res.success) {
        alert(
          poId
            ? "Purchase Order Updated Successfully"
            : "Purchase Order Created Successfully"
        );
        onClose();
      } else {
        alert(res.message || "Failed to save PO");
      }
    } catch (err) {
      alert(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.4)",
          zIndex: 9998,
        }}
        onClick={onClose}
      />

      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: maximized ? "100%" : "900px",
          height: "100%",
          background: "#fff",
          zIndex: 9999,
          overflowY: "auto",
          boxShadow: "-4px 0 12px rgba(0,0,0,0.1)",
          transition: "width 0.2s ease-in-out"
        }}
      >

        <div
          style={{
            background: "#4f46e5",
            color: "#fff",
            padding: "14px 16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <h5 style={{ margin: 0 }}>
            {poId ? "Edit Purchase Order" : "Create Purchase Order"}
          </h5>

          <div>
            <button
              onClick={() => setMaximized(!maximized)}
              style={{
                background: "none",
                border: "none",
                color: "#fff",
                fontSize: "18px",
                marginRight: "10px",
                cursor: "pointer"
              }}
            >
              {maximized ? "❐" : "⛶"}
            </button>

            <button
              style={{
                background: "none",
                border: "none",
                color: "#fff",
                fontSize: 20,
                cursor: "pointer"
              }}
              onClick={onClose}
            >
              ×
            </button>
          </div>
        </div>

        <div style={{ padding: 16 }}>

          <POHeaderSection
            form={form}
            setForm={setForm}
            selectedVendor={selectedVendor}
            setSelectedVendor={setSelectedVendor}
          />

          <div className="mb-3">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={() => setShowTermsDrawer(true)}
            >
              Terms & Conditions
            </button>
          </div>

          <POLineItemsTable
            lines={lines}
            setLines={setLines}
            getLineTotal={getLineTotal}
          />
          <POChargeTable
              charges={charges}
              setCharges={setCharges}
          />

          <div className="text-end mt-3">
            <h6>Sub Total: {getSubTotal().toFixed(2)}</h6>
            <h6>Total GST: {getTotalGST().toFixed(2)}</h6>
            <h6>Grand Total: {getTotal().toFixed(2)}</h6>
          </div>

        </div>

        <POFooterActions
          onClose={onClose}
          onSubmit={handleSubmit}
          saving={saving}
        />

      </div>

      {showTermsDrawer && (
        <POTermsConditionsDrawer
          terms={terms}
          setTerms={setTerms}
          onClose={() => setShowTermsDrawer(false)}
        />
      )}
    </>
  );
};

export default POCreateDrawer;
